import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/util/util.service';
import { EasyEatHqService } from '../services/ee-hq.service';
import { LocalStorageService } from './localStorage.service';

@Injectable()
export class AuthService {
  private isAuthenticated: boolean = false;
  private hqRoutesMap = {
    'hq/dashboard': 'CAN_VIEW_HQ',
    'hq/outlets': 'CAN_VIEW_HQ_OUTLETS',
    'hq/reports': 'CAN_VIEW_HQ_REPORT',
    'hq/settlement': 'CAN_VIEW_HQ_SETTLEMENT',
    'hq/inventory': 'CAN_VIEW_HQ_INVENTORY_LIST',
    'hq/loyalty': 'CAN_VIEW_HQ_LOYALTY_SETTINGS',
    'hq/analytics': 'CAN_VIEW_HQ_RESTAURANT_ANALYTICS',
    'hq/discounts': 'CAN_VIEW_HQ_PROMOTION_SETTINGS',
    'hq/e-invoice': 'CAN_VIEW_HQ',
  };
  constructor(
    private router: Router,
    public utilService: UtilService,
    private hqService: EasyEatHqService,
    private _localStorage: LocalStorageService
  ) {}

  public isRouteAuthenticated(): boolean {
    if (
      localStorage.getItem('ee_user_type') === 'rest_hq_admin' ||
      localStorage.getItem('ee_user_type') === 'rest_hq_staff' ||
      !this.utilService.isLockEnabled() ||
      localStorage.getItem('blocked') == '0' ||
      (this._localStorage.get('isRealmEnabled') === '1')
    ) {
      return true;
    } else {
      return this.isAuthenticated;
    }
  }

  public setIsAuthenticated(isAuth: boolean): void {
    this.isAuthenticated = isAuth;
  }

  public isValidPermission(permission) {
    let isHqLoggedIn = this.hqService.hqStatus;
    if (!this.utilService.isLockEnabled() && !isHqLoggedIn) {
      return true;
    }

    try {
      let all_permissions = [];
      let isHqPermission = permission.includes('_HQ');

      // all_permissions = JSON.parse(localStorage.getItem('user_permissions'));
      all_permissions = JSON.parse(this._localStorage.get('user_permissions'));

      // Is HQ user logged in
      if (this.hqService.hqStatus) {
        return isHqPermission ? all_permissions.indexOf(permission) > -1 : true;
      }
      // Is POS user logged in
      else {
        return !isHqPermission
          ? all_permissions.indexOf(permission) > -1
          : true;
      }
    } catch (error) {
      return false;
    }
  }

  public isURLAuthenticated(route) {
    let is_valid = true;
    let isHqLoggedIn = this.hqService.isHqUser();

    if ((!this.utilService.isLockEnabled() && !isHqLoggedIn) || (this._localStorage.get('isRealmEnabled') === '1')) {
      return is_valid;
    }
    // HQ routes view access
    else if (isHqLoggedIn) {
      if (this.hqRoutesMap[route])
        is_valid = this.isValidPermission(this.hqRoutesMap[route]);
    } else if (!isHqLoggedIn) {
      // POS routes view access
      if (route.indexOf('/reports') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_REPORT');
      } else if (route.indexOf('/section-counters') > -1) {
        is_valid =
          this.isValidPermission('CAN_VIEW_SECTION_SETTINGS') ||
          this.isValidPermission('CAN_VIEW_PRINTER_SETTINGS');
      } else if (route.indexOf('/loyalty') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_LOYALTY_SETTINGS');
      } else if (route.indexOf('/inventory') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_INVENTORY_LIST');
      } else if (route.indexOf('/discounts') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_PROMOTION');
      } else if (route.indexOf('/tableservice') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_TABLE_SERVICE');
      } else if (route.indexOf('/table-bookings') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_TABLE_SERVICE');
      } else if (route.indexOf('/analytics') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_RESTAURANT_ANALYTICS');
      } else if (route.indexOf('/menu') > -1) {
        is_valid = this.isValidPermission('CAN_VIEW_MENU_ITEM');
      } else if (route.indexOf('/settlement') > -1){
        is_valid = true;
      }
    }

    return is_valid;
  }
}
